
<script>
	
	import listBase from '@_system/components/base/list.vue'
	import editIndex from './edit/index.vue'
	export default {
		extends: listBase,
		name: 'inventoryquantityadjustIndex',
		props: {

		},
		render(h) {
			this.$slots.plug = [
				<edit-index row={this.currentrow} ref="inventoryquantityadjustEditIndex" />,			
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				moduleName: 'inventoryquantityadjust',
				windowName: '库存盘点预警',
				windowType: 'modal',
				currentrow:null
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			edit(row) {
				this.currentrow = row
				this.$refs.inventoryquantityadjustEditIndex.modal_show()
			},
		},
		components: {
			editIndex	
		}
	}
</script>
